<template>
  <div>
    <!-- toasts message -->
    <v-card color="grey lighten-4">
      <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    </v-card>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <insertForm :formSchema="formSchema" v-on:emitForm="close" v-if="showForm"></insertForm>

    <v-container>
      <v-card>
        <v-card-title>
          <h2>Asset Master List</h2>
          <v-spacer></v-spacer>
          <v-text-field
            append-icon="search"
            label="Search"
            single-line
            hide-details
            v-model="search"
          ></v-text-field>
        </v-card-title>
        <span style="display:none;">{{serial=serialNumber}}</span>
        <v-data-table
          :headers="headers"
          :items="desserts"
          :pagination.sync="pagination"
          :total-items="totalDesserts"
          :loading="loading"
          class="elevation-4"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ serial++ }}</td>
            <td class="text-xs-left" v-if="props.item.asset_code">{{ props.item.asset_code }}</td>
            <td class="text-xs-left" v-if="! props.item.asset_code">N/A</td>
            <td class="text-xs-left">{{ props.item.item_name }}</td>
            <td class="text-xs-left">
              {{props.item.package_name}}
            <!-- {{ (props.item.package_no != 'null') ? (props.item.package_name).slice(0, 20) + '...' : "N/A" }} -->
          </td>
            <td class="text-xs-left">{{ changeFormateDMY(props.item.purchase_date) }}</td>
            <td class="text-xs-left">{{ props.item.purchase_price }}</td>
            <td class="text-xs-left">{{ props.item.status_title }}</td>
            <td class="text-xs-left">{{ props.item.quantity }}</td>
            <td class="text-xs-left">{{ props.item.unit_name }}</td>
            <td class="text-xs-left">{{ props.item.asset_location_name }}</td>

            <td class="justify-center layout px-0">
              <v-btn
                icon
                class="mx-0"
                v-if="userRole.updateButton"
                @click="editItem(props.index,props.item)"
              >
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                v-if="userRole.deleteButton"
                @click="deleteItem(props.index, props.item.id)"
              >
                <v-icon color="pink">delete</v-icon>
              </v-btn>
              <v-btn icon class="" @click="copyItem(props.index, props.item)" title="Copy">
                <v-icon color="teal">file_copy</v-icon>
              </v-btn>

            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
let commonService = require("../../../services/common.service");
import insertForm from "./asset_master_form";

export default {
  components: {
    insertForm
  },

  data: () => ({
    showForm: false, // Add edit form controll during user permission
    dialog: false,
    totalItems: 0,
    items: [],
    //Delete data related instance--------
    delete_id: "",
    row_index: "",
    confirmModel: false,

    // snacber script instance ----------
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },

    formSchema: {
      id: "",
      item_id: "",
      asset_code: "",
      purchase_date: "",
      purchase_name: "",
      purchase_price: "",
      package_no: "",
      package_code: "",
      asset_status: 2,
      asset_location_name: "",
      asset_sub_category: "",
      asset_location: 1,
      is_fixed_asset: "",
      quantity: 1,
      unit_id: ""
    },

    /*############# Datatable #############*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      { text: "SL", value: "" },
      {
        text: "Asset Code",
        align: "left",
        sortable: true,
        value: "asset_code"
      },
      {
        text: "Asset Name",
        align: "left",
        sortable: true,
        value: "item_name"
      },
      {
        text: "Package Number",
        align: "left",
        sortable: true,
        value: "package_name"
      },
      { text: "Purchase Date", sortable: true, value: "purchase_date" },
      { text: "Purchase Price", value: "purchase_price" },
      { text: "Asset Status", value: "asset_status" },
      { text: "Quantity", value: "quantity" },
      { text: "Unit", value: "unit_name" },
      { text: "Asset Location", value: "asset_location_name" },
      { text: "Action", value: "" }
    ]
    /*############# /Datatable #############*/
  }),

  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          if ( typeof(data.items) !== 'undefined') {
            this.desserts = data.items;
          }
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    },
    // User Previlization methods
    userRole() {
      let role = this.$store.getters.get_USER_ROLE_DATA;
      this.showForm = role.saveButton;
      return role;
    }
  },

  methods: {
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "asset_master_info")
          .then(res => {
            this.showForm = this.userRole.saveButton;
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    copyItem(index, data) {
      // Data edit form prepare
      this.showForm = true;
      data.purchase_date = this.changeFormateDMY(data.purchase_date);
      this.formSchema = { ...data };

      commonService
        .getAllDataById(data.id, 'get_new_code')
        .then(res => {
          this.formSchema.asset_code = res.new_code;
      });

      this.formSchema.id = 0;
      this.row_index = index;

      // var type = this.formSchema.is_fixed_asset;
      // type == 1 ? (this.disabled = true) : (this.disabled = false);
      window.scrollTo({
        // scroling to top
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    },

    editItem(index, data) {
      // Data edit form prepare
      this.showForm = true;
      data.purchase_date = this.changeFormateDMY(data.purchase_date);
      this.formSchema = { ...data };
      this.row_index = index;
      // var type = this.formSchema.is_fixed_asset;
      // type == 1 ? (this.disabled = true) : (this.disabled = false);
      window.scrollTo({
        // scroling to top
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    },

    deleteItem(index, id) {
      // data delete confirm modal
      this.row_index = index;
      this.delete_id = id;
      this.confirmModel = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "asset_master").then(res => {
        if (res.status == 1) {
          this.desserts.splice(row_index, 1);
        }
        this.close(res);
        this.confirmModel = false;
      });
    },

    //  Request response Massage !!!
    //  Request response Massage !!!
    close(res) {
      this.showForm = this.userRole.saveButton;
      if (res.status == 1) {
        this.SnackbarVal.color = "success";
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        if (res.action == "add") {
          this.desserts.unshift({ ...res.data });
        }
        if (res.action == "edit") {
          this.$set(this.desserts, this.row_index, { ...res.data });
          this.row_index = "";
        }
        window.scrollTo({
          left: 0,
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
          behavior: "smooth"
        });
      } else {
        this.SnackbarVal.color = "error";
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
      }
    }
    // End  Request response Massage !!!
  }
};
</script>



// WEBPACK FOOTER //
// src/components/asset/asset_master/asset_master_list.vue